import { defineChain } from 'viem'

/** Robinhood Chain mainnet の viem 接続定義。 */
export const robinhood = defineChain({
  id: 4663,
  name: 'Robinhood Chain',
  nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
  rpcUrls: { default: { http: ['https://rpc.mainnet.chain.robinhood.com'] } },
  blockExplorers: {
    default: {
      name: 'Robinhood Etherscan',
      url: 'https://robin.etherscan.io',
      apiUrl: 'https://api.etherscan.io/v2/api?chainid=4663',
    },
  },
  testnet: false,
})
